export const GTM_TYPES = {
  CREDITS: 'Credits',
  DFY_ORDER: 'DFY: Order',
  EMAILS: 'Emails',
  DFY_MONTHLY_SUBSCRIPTION: 'DFY: Monthly Subscription',
  DIY_MAINTENANCE_SUBSCRIPTION: 'DIY: Maintenance Subscription',
  CONTACTS: 'Contacts',
  DFY_BALANCE_TOPUP: 'DFY: Balance Top-up',
};
